(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/oddset/kambi-offering/assets/javascripts/hooks/use-bet-offer-sockets.js') >= 0) return;  svs.modules.push('/components/oddset/kambi-offering/assets/javascripts/hooks/use-bet-offer-sockets.js');
"use strict";

var _svs$oddset, _svs$oddset2;
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState;
const kambiPushApiUrl = (_svs$oddset = svs.oddset) === null || _svs$oddset === void 0 || (_svs$oddset = _svs$oddset.kambiOfferingApiUrl) === null || _svs$oddset === void 0 || (_svs$oddset = _svs$oddset.data) === null || _svs$oddset === void 0 ? void 0 : _svs$oddset.kambiPushApiUrl;
const kambiOfferingSocketChannelPrefix = (_svs$oddset2 = svs.oddset) === null || _svs$oddset2 === void 0 || (_svs$oddset2 = _svs$oddset2.kambiOfferingApiUrl) === null || _svs$oddset2 === void 0 || (_svs$oddset2 = _svs$oddset2.data) === null || _svs$oddset2 === void 0 ? void 0 : _svs$oddset2.kambiOfferingSocketChannelPrefix;
const logger = new svs.core.log.Logger('components:oddset:kambi-offering:hooks:useBetOfferSockets');
const LANGUAGE = 'sv_SE';
const MAXIMUM_ATTEMPTS = 5;
const useBetOfferSockets = (eventId, onMessageCallback, shouldConnectSockets) => {
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    error = _useState2[0],
    setError = _useState2[1];
  useEffect(() => {
    if (!shouldConnectSockets) {
      logger.info("Kambi event ".concat(eventId, " opted out socket updates."));
      return;
    }
    if (!eventId) {
      const error = "Missing eventId. Not opening socket connection";
      logger.error(error);
      setError(error);
      return;
    }
    if (!kambiPushApiUrl || !kambiOfferingSocketChannelPrefix) {
      const error = "Missing values from zookie config. kambiPushApiUrl = ".concat(kambiPushApiUrl, " | kambiOfferingSocketChannelPrefix = ").concat(kambiOfferingSocketChannelPrefix);
      logger.error(error);
      setError(error);
      return;
    }
    const socket = io(kambiPushApiUrl, {
      transports: ['websocket'],
      upgrade: false,
      autoConnect: false,
      path: '/socket.io'
    });
    socket.on('connect', () => {
      logger.debug('Socket connected');
    });
    socket.on('disconnect', reason => {
      logger.info("Socket disconnected: ".concat(reason));
    });
    socket.on('reconnect', attemptNumber => {
      logger.info("Socket reconnected after ".concat(attemptNumber, " attempts."));
    });
    socket.on('error', error => {
      const errorMsg = "Socket error: ".concat(error);
      logger.error(errorMsg);
      setError(errorMsg);
    });
    socket.on('reconnect_attempt', attemptNumber => {
      logger.info("Socket reconnect attempt ".concat(attemptNumber));
      if (attemptNumber >= MAXIMUM_ATTEMPTS) {
        logger.error("Closing socket after ".concat(attemptNumber, " reconnection attempts."));
        socket.close();
      }
    });
    socket.on('message', incomingMessage => onMessageCallback(JSON.parse(incomingMessage)));
    socket.open();
    const languageSpecificChannel = "".concat(kambiOfferingSocketChannelPrefix, ".").concat(LANGUAGE, ".ev.").concat(eventId, ".json");
    const nonLocalizedChannel = "".concat(kambiOfferingSocketChannelPrefix, ".ev.").concat(eventId, ".json");
    socket.emit('subscribe', {
      topic: languageSpecificChannel
    });
    socket.emit('subscribe', {
      topic: nonLocalizedChannel
    });
    return () => {
      socket.emit('unsubscribe', {
        topic: languageSpecificChannel
      });
      socket.emit('unsubscribe', {
        topic: nonLocalizedChannel
      });
    };
  }, [eventId, shouldConnectSockets, onMessageCallback]);
  return {
    error
  };
};
setGlobal('svs.components.oddset.kambiOffering.hooks.useBetOfferSockets', useBetOfferSockets);

 })(window);